module.exports = __webpack_public_path__ + "img/icb.2c06f7fc.svg";